import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
  },
  state: {
    snackbarMessage: "",
    snackbarColor: "",
    isSnackbarVisible: false,
    loading: false, // Menyimpan status loading
    title: "",
    totalApprovals: 0,
  },
  getters: {},
  mutations: {
    set_snackbar(state, { message, isSuccess }) {
      state.snackbarMessage = message;
      state.snackbarColor = isSuccess ? "green" : "red";
      state.isSnackbarVisible = false; // Reset ke false
      setTimeout(() => {
        state.isSnackbarVisible = true; // Aktifkan kembali di event loop berikutnya
      }, 0);
    },
    hide_snackbar(state) {
      state.isSnackbarVisible = false;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    addMessage(state, message) {
      state.messages.push(message);
    },
    setTitle(state, newTitle) {
      state.title = newTitle; // Perubahan dilakukan di sini
    },
    setTotalApprovals(state, newTotalApprovals) {
      state.totalApprovals = newTotalApprovals; // Perubahan dilakukan di sini
    },
    getLast30Days() {
      const today = new Date();
      const pastDate = new Date();
      pastDate.setDate(today.getDate() - 30); // Mundur 30 hari

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return {
        start: formatDate(pastDate), // Tanggal 30 hari lalu
        end: formatDate(today), // Tanggal hari ini
      };
    },
  },
  actions: {
    triggerSnackbar({ commit }, { message, isSuccess }) {
      commit("set_snackbar", { message, isSuccess });
    },
    showLoading({ commit }) {
      commit("setLoading", true); // Set loading menjadi true
    },
    hideLoading({ commit }) {
      commit("setLoading", false); // Set loading menjadi false
    },
  },
});
